import { DateTime } from "luxon";
import { roleConfig } from "./clients/clients.constants";

export const getDateString = (dateTimeString) => {
  try {
    const date = DateTime.fromJSDate(dateTimeString);

    if (!date.isValid) {
      return "-";
    }

    return date.toISO();
  } catch (error) {
    return null;
  }
};

export const formatAlertsTableDateTime = (dateTimeString) => {
  try {
    const date = DateTime.fromISO(dateTimeString, { zone: 'local' });

    if (!date.isValid) {
      return "-";
    }

    return date.toFormat('MM/dd/yyyy HH:mm:ss');
  } catch (error) {
    return "-";
  }
};

export const makeSafeKey = (key) =>
    key.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');

export const isRouteVisible = (userRoles, route) => {
  if (!userRoles || userRoles.length === 0) return false;

  for (const role of userRoles) {
    const config = roleConfig[role];

    if (config) {
      const normalizedAllowedPaths = config.allowedPaths.map((path) =>
        path.replace(/\/+$/, "").toLowerCase()
      );
      if (normalizedAllowedPaths.includes("*") || normalizedAllowedPaths.includes(route)) {
        return true;
      }
    }
  }

  return false;
};

export const getYearMonthDay = (selectedDate) => {
  let dt;

  if (selectedDate) {
    if (typeof selectedDate === "string") {
      dt = DateTime.fromISO(selectedDate);
    } else if (selectedDate instanceof Date) {
      dt = DateTime.fromJSDate(selectedDate);
    } else {
      dt = DateTime.fromJSDate(new Date(selectedDate));
    }
  }

  if (!dt || !dt.isValid) {
    dt = DateTime.local();
  }

  return {
    year: dt.year,
    month: dt.month,
    day: dt.day,
  };
}